export type CodeType = 'ICD' | 'CPT' | 'MODIFIER';

export const CODE_TYPES: readonly CodeType[] = ['ICD', 'CPT', 'MODIFIER'];

export const CODE_TYPE_LABEL: Readonly<Record<CodeType, string>> = {
  ICD: 'ICD-10',
  CPT: 'CPT',
  MODIFIER: 'Modifier'
};

export const minSearchLength = (codeType: CodeType): number =>
  codeType === 'MODIFIER' ? 2 : 3;

export type CodeSearchResult = {
  readonly code: string;
  readonly description: string;
};

export type RelatedCodeItem = {
  readonly code: string;
  readonly description: string;
  readonly specialty?: string;
  readonly dos?: string;
};

export type EvidenceSpanRef = {
  readonly id: string;
  readonly text: string;
};

export type AddCodeInput = {
  readonly codeType: CodeType;
  readonly code: string;
  readonly description: string;
  readonly spans?: readonly EvidenceSpanRef[];
};
